/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import HeaderLight from "../../../../common/header/HeaderLight";
import FooterOne from "../../../../common/footer/FooterOne";

import banner from "../../../../../src/app/assets/images/cds-blog/banner.jpg";

const products = () => {
  return (
    <div className="blog-list_page">
      <HeaderLight />
      <div class="container-fluid pt-0 px-0 margin-minus">
        <div class="blog-banner">
          <img alt="" class="img-fluid rounded-3 pb-5" src={banner} />
          <h2>BLOG</h2>
        </div>
      </div>

      <div className="container section-padding pt-0">
        <div className="row blog-list">
          <div className="col-xxl-4 col-lg-4 col-md-6">
            <div class="item">
              <h2>
                <a href="/the-importance-of-ui-ux-design-in-todays-digital-landscape">
                  The Importance of UI/UX Design in Today’s Digital Landscape
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Arun Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    May 2, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Mastering UI/UX Design The Importance of UI/UX Design in
                  Today’s Digital Landscape Imagine walking into a store where
                  everything is cluttered, confusing, and impossible to find.
                  That’s what a website with poor UI/UX design feels like. In
                  today’s digital world, where attention spans are shorter than
                  ever, effective UI/UX design is no longer a nicety, […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/the-importance-of-ui-ux-design-in-todays-digital-landscape"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/optimizing-customer-service-with-ai-powered-solutions">
                  Optimizing Customer Service with AI-powered Solutions
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Prakash Natraj</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 26, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Elevate your Customer Service with AI Optimizing Customer
                  Service with AI-powered Solutions Imagine a world where
                  customer service is faster, more efficient, and available
                  24/7. That’s the promise of AI-powered solutions in today’s
                  customer service landscape. At CAP Digisoft, we’re passionate
                  about creating exceptional customer experiences. We believe AI
                  can be a powerful tool to […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/optimizing-customer-service-with-ai-powered-solutions"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/customer-success-the-engine-of-enduring-business-triumph">
                  Customer Success: The Engine of Enduring Business Triumph
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Arun Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 12, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Customer Success as a Service Customer Success: The Engine of
                  Enduring Business Triumph In the high-speed, ultra-competitive
                  realm of technology, where every startup and tech giant is
                  racing to out-innovate each other, a new success metric has
                  emerged, quietly taking the throne as the ultimate
                  game-changer: customer success. Dive deep into the tech
                  industry’s latest […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/customer-success-the-engine-of-enduring-business-triumph"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/accelerating-market-launch-the-power-of-expertise">
                  Accelerating Market Launch: The Power of Expertise
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Prakash Natraj</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 8, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Market Launch Mastery Accelerating Market Launch: The Power of
                  Expertise In the adrenaline-fueled tech ecosystem, where the
                  difference between being a market leader and a laggard can be
                  measured in days, the rush to get from whiteboard to
                  storefront has never been more intense. With over 30,000 new
                  products introduced every year, according to Harvard […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/accelerating-market-launch-the-power-of-expertise"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/crafting-market-leaders-how-idea-to-product-services-forge-the-future">
                  Crafting Market Leaders: How Idea to Product Services Forge
                  the Future
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Barath Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    March 27, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Navigating the Future Crafting Market Leaders: How Idea to
                  Product Services Forge the Future Diving headfirst into the
                  tech revolution, the journey from a mere flicker of an idea to
                  dominating the market is more akin to a rollercoaster ride in
                  the dark. Here’s where the magicians of idea to product
                  services step into the […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/crafting-market-leaders-how-idea-to-product-services-forge-the-future"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/mastering-the-product-development-lifecycle-leveraging-stats-for-success">
                  Mastering the Product Development Lifecycle: Leveraging Stats
                  for Success
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Arun Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    February 28, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Software Product Development Lifecycle Mastering the Product
                  Development Lifecycle: Leveraging Stats for Success The
                  Critical Role of Long-Term Strategic Planning in Product
                  Development In the ever-evolving world of product development,
                  understanding the lifecycle from ideation to execution is not
                  just beneficial—it’s critical. Yet, startling statistics
                  reveal that only 13% of companies have detailed roadmaps for
                  […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/mastering-the-product-development-lifecycle-leveraging-stats-for-success"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/ais-cash-tsunami-and-the-innovation-race-how-techs-betting-big-and-why-millennials-are-all-in">
                  AI’s Cash Tsunami and the Innovation Race: How Tech’s Betting
                  Big and Why Millennials Are All In
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Prakash Natraj</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    February 21, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Artificial intelligence’s power AI’s Cash Tsunami and the
                  Innovation Race: How Tech’s Betting Big and Why Millennials
                  Are All In In the tech universe, where the only constant is
                  rapid-fire change, a jaw-dropping surge in AI funding from
                  $32.1 billion to a whopping $66.8 billion in 2021 marks a
                  seismic shift. This isn’t just growth; […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/ais-cash-tsunami-and-the-innovation-race-how-techs-betting-big-and-why-millennials-are-all-in"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            {/* <div class="item">
              <h2>
                <a href="/">
                  How Idea Booster Programs Are Powering the Next Wave of App
                  Development
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Gerald Valentine</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    February 16, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  The mobile app market’s valuation How Idea Booster Programs
                  Are Powering the Next Wave of App Development In an era where
                  the mobile app market’s valuation soared to a whopping $206.85
                  billion in 2022, and a staggering 48% of small businesses
                  jumped on the app bandwagon, the tech world is witnessing a
                  gold rush of […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="https://capdigisoft.com/blog/optimizing-customer-service-with-ai-powered-solutions/"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div> */}
          </div>
          <div className="col-xxl-4 col-lg-4 col-md-6">
            <div class="item">
              <h2>
                <a href="/building-a-fortress-enhancing-web-security-in-2024">
                  Building a Fortress: Enhancing Web Security in 2024
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Arun Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 24, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Web Security in Today’s Digital Landscape Building a Fortress:
                  Enhancing Web Security in 2024 The internet is like a bustling
                  marketplace – a treasure trove of information and connection,
                  but also a place where you need to be vigilant. With cyber
                  threats constantly evolving, fortifying your website’s
                  security is no longer optional, it’s essential. Here […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/building-a-fortress-enhancing-web-security-in-2024"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/scaling-success-the-top-5-customer-success-strategies-winning-todays-tech-race">
                  Scaling Success: The Top 5 Customer Success Strategies Winning
                  Today’s Tech Race
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Prakash Natraj</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 15, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Customer Success Strategies Scaling Success: The Top 5
                  Customer Success Strategies Winning Today’s Tech Race In
                  today’s cutthroat business arena, where every startup and tech
                  giant is vying for the spotlight, nailing customer success
                  isn’t just a trophy—it’s the entire game. With the stakes
                  sky-high, we’re slicing through the noise to spotlight the top
                  5 […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/scaling-success-the-top-5-customer-success-strategies-winning-todays-tech-race"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/empathy-as-strategy-how-customer-success-is-redefining-techs-winners">
                  Empathy as Strategy: How Customer Success Is Redefining Tech’s
                  Winners
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Arun Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 5, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Customer Success Empathy as Strategy: How Customer Success Is
                  Redefining Tech’s Winners In the tech ecosystem’s relentless
                  quest for dominance, a game-changing strategy is making waves,
                  proving that the heart of innovation beats not just through
                  groundbreaking tech but through groundbreaking relationships:
                  customer success. This holistic, proactive approach to
                  ensuring customer satisfaction isn’t just nice […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/empathy-as-strategy-how-customer-success-is-redefining-techs-winners"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/decoding-success-vital-metrics-for-gauging-customer-impact-and-business-growth">
                  Decoding Success: Vital Metrics for Gauging Customer Impact
                  and Business Growth
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Prakash Natraj</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    March 25, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Streamlining for Growth Decoding Success: Vital Metrics for
                  Gauging Customer Impact and Business Growth Navigating the
                  complex terrain of global business dynamics, the significance
                  of discerning the influence of customer success efforts on
                  business expansion cannot be overstated. With small and medium
                  enterprises (SMEs) representing 90% of the global business
                  population and serving as the […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/decoding-success-vital-metrics-for-gauging-customer-impact-and-business-growth"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/how-csaas-is-rewriting-the-rulebook-on-customer-experience-and-revenue-growth">
                  How CSaaS is Rewriting the Rulebook on Customer Experience and
                  Revenue Growth
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Barath Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    February 23, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Customer Success as a Service How CSaaS is Rewriting the
                  Rulebook on Customer Experience and Revenue Growth In the
                  constantly evolving tech landscape, there’s one trend that’s
                  not just making waves but also reshaping the shores of
                  customer engagement and business growth: Customer Success as a
                  Service (CSaaS). With the digital economy booming, businesses
                  are […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/how-csaas-is-rewriting-the-rulebook-on-customer-experience-and-revenue-growth"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/navigating-the-app-odyssey-from-spark-to-spectacle">
                  Navigating the App Odyssey: From Spark to Spectacle
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Arun Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    February 16, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  A spark of inspiration to a spectacle Navigating the App
                  Odyssey: From Spark to Spectacle In the digital coliseum where
                  only the mightiest apps survive, the journey from a spark of
                  inspiration to a spectacle in users’ hands is both daunting
                  and exhilarating. With CAP Digisoft’s “Idea to Product”
                  roadmap as our compass, we’re diving […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/navigating-the-app-odyssey-from-spark-to-spectacle"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            {/* <div class="item">
              <h2>
                <a href="/">
                  The Transformative Power of Short Videos in Today’s Marketing
                  Landscape
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Gerald Valentine</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    November 6, 2023
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Capturing Attention in Seconds​ The Transformative Power of
                  Short Videos in Today’s Marketing Landscape Because the
                  marketplace of ideas is currently marked by information
                  overload and fleeting attention spans, capturing the interest
                  of your audience has become a formidable challenge. The
                  digital age has revolutionized the way we consume content,
                  giving rise to a culture […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="https://capdigisoft.com/blog/optimizing-customer-service-with-ai-powered-solutions/"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div> */}
          </div>
          <div className="col-xxl-4 col-lg-4 col-md-6">
            <div class="item">
              <h2>
                <a href="/the-digital-craftsmen-essential-tech-for-next-gen-product-development">
                  The Digital Craftsmen: Essential Tech for Next-Gen Product
                  Development
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Barath Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 17, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  App Idea Booster and Product Development The Digital
                  Craftsmen: Essential Tech for Next-Gen Product Development
                  Stepping into the future of product development feels a lot
                  like wielding the tools of a wizard—each new technology adds a
                  layer of magic, transforming how we bring our most innovative
                  ideas to life. This evolution is driven by digital […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/the-digital-craftsmen-essential-tech-for-next-gen-product-development"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/innovation-unleashed-how-idea-booster-initiatives-are-transforming-corporate-culture">
                  Innovation Unleashed: How Idea Booster Initiatives Are
                  Transforming Corporate Culture
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Barath Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 10, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Software App Idea Booster Innovation Unleashed: How Idea
                  Booster Initiatives Are Transforming Corporate Culture In an
                  era where innovation is the lifeblood of corporate survival
                  and growth, businesses are constantly on the lookout for
                  methods to foster creativity and innovative thinking within
                  their teams. Amid this pursuit, one of the most promising
                  developments is the […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/innovation-unleashed-how-idea-booster-initiatives-are-transforming-corporate-culture"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/navigating-the-software-development-boom-a-techcrunch-deep-dive">
                  Navigating the Software Development Boom: A TechCrunch Deep
                  Dive
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Barath Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    April 4, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  The Software Development Surge Navigating the Software
                  Development Boom: A TechCrunch Deep Dive In the fast-paced
                  world of tech, the software development market is hitting
                  speeds we’ve barely seen before, rocketing towards a whopping
                  $1039 million valuation by 2027. That’s a head-spinning CAGR
                  of 22.54% from 2020 to 2027, folks. For anyone knee-deep in
                  the […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/navigating-the-software-development-boom-a-techcrunch-deep-dive"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <h2>
                <a href="/ai-and-personalization-the-new-frontier-in-saas-customer-success">
                  AI and Personalization: The New Frontier in SaaS Customer
                  Success
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Arun Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    March 1, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Artificial Intelligence (AI) AI and Personalization: The New
                  Frontier in SaaS Customer Success In the realm of SaaS, a
                  revolution is brewing, and it’s all about delivering unmatched
                  customer experiences through the power of AI and deep
                  personalization. As we venture into the next year, a whopping
                  72% of business leaders are betting big on […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/ai-and-personalization-the-new-frontier-in-saas-customer-success"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            {/* <div class="item">
              <h2>
                <a href="/the-tech-infused-outsourcing-strategy-revolutionizing-product-development">
                  The Tech-Infused Outsourcing Strategy: Revolutionizing Product
                  Development
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Gerald Valentine</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    February 26, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Software Product Development The Tech-Infused Outsourcing
                  Strategy: Revolutionizing Product Development In the
                  high-stakes world of product launches, where nearly two-thirds
                  of projects either fall short or get bogged down by delays,
                  technology and outsourcing have emerged as twin saviors. These
                  power players are not just reshaping the battlefield; they’re
                  setting new rules for victory in […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/the-tech-infused-outsourcing-strategy-revolutionizing-product-development"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div> */}
            <div class="item">
              <h2>
                <a href="/proactive-success-services-the-future-of-customer-care-in-tech">
                  Proactive Success Services: The Future of Customer Care in
                  Tech
                </a>
              </h2>
              <hr />
              <div class="blog-list-header">
                <span class="blog-author">Arun Kumar</span>
                <br></br>
                <span class="blog-history">
                  <i aria-hidden="true" class="icon icon-calendar3"></i>
                  <span class="meta-date-text d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar4 me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                    </svg>
                    February 19, 2024
                  </span>
                </span>
              </div>
              <div class="blog-list-body">
                <p>
                  Customer Success as a Service Proactive Success Services: The
                  Future of Customer Care in Tech The digital age has ushered in
                  an era of unprecedented competition among tech companies,
                  where the battle for customer loyalty is won and lost not just
                  on the innovation front but also in the trenches of customer
                  support. With roughly […]
                </p>
                <div class="btn-wraper">
                  <a
                    href="/proactive-success-services-the-future-of-customer-care-in-tech"
                    class="elementskit-btn  whitespace--normal"
                  >
                    Learn more{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </div>
  );
};

export default products;
